import { Configuration } from './Configuration';

export class ConfigurationZone {
  /**
   * constructor description
   * @param {Object} configuration - An object.
   * @param  {Number} configuration.zone
   * @param  {Configuration[]} configuration.ranges
  */
  constructor({
    zone, ranges,
  }) {
    this.zone = zone;
    this.ranges = ranges.map((range) => new Configuration(range));
  }

  static createEmpty() {
    const zone = 1;
    const config = {
      range: [1, 2],
      cost: 1,
      start_date: new Date().toISOString(),
      end_date: new Date().toISOString(),
    };
    const ranges = [config];
    return new ConfigurationZone({ zone, ranges });
  }

  addRange() {
    const config = Configuration.createEmpty();
    this.ranges.push(config);
  }
}
